import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import { AboutPage, ContactPage, QuotePage, BlogIndexPage } from "./pages/StaticPages";
import { PrivacyPage, TermsPage, PromoPage } from "./pages/LegalPages";
import AuthPage from "./pages/AuthPage";
import DashboardLayout from "./pages/DashboardLayout";
import Overview from "./pages/dashboard/Overview";
import Orders from "./pages/dashboard/Orders";
import Designs from "./pages/dashboard/Designs";
import Addresses from "./pages/dashboard/Addresses";
import Settings from "./pages/dashboard/Settings";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const hideChrome = pathname === "/signin" || pathname === "/signup";
  return (
    <>
      {!hideChrome && <Header />}
      {children}
      {!hideChrome && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-white text-zinc-900 antialiased">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Chrome>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<CategoryPage />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/product/:slug" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/quote" element={<QuotePage />} />
                <Route path="/promo" element={<PromoPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/blog" element={<BlogIndexPage />} />
                <Route path="/blog/:slug" element={<BlogIndexPage />} />

                {/* Auth */}
                <Route path="/signin" element={<AuthPage />} />
                <Route path="/signup" element={<AuthPage />} />

                {/* Dashboard */}
                <Route path="/account" element={<DashboardLayout />}>
                  <Route index element={<Overview />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="designs" element={<Designs />} />
                  <Route path="addresses" element={<Addresses />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </Chrome>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
